// extracted by mini-css-extract-plugin
export default {"container":"container__0c2a31fd","curation_list":"curation_list__0c2a31fd","curation_item":"curation_item__0c2a31fd"};